/* ATR — vVP behaviour: quantity steppers, tap-to-choose product cards, inline add-to-cart confirmation. */
(() => {
  const clear = except => document.querySelectorAll('.atr-product-tile.is-open').forEach(t => { if (t !== except) t.classList.remove('is-open'); });

  /* ---- Coming soon: the "pick a size first" warning only appears once it is true ----
     It is rendered visible so that it still reads as an instruction without JS; with
     JS the product section reveals it only when the notify button is pressed with no
     size chosen. */
  const hideSizeHints = () => document.querySelectorAll('[data-atr-cs-hint]').forEach(hint => { hint.hidden = true; });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideSizeHints); else hideSizeHints();
  document.addEventListener('shopify:section:load', hideSizeHints);

  /* ---- Inline confirmation when a size is picked on a product card ---- */
  const flash = (panel, message, ok, href) => {
    let note = panel.querySelector('.atr-quick-added');
    if (!note) {
      note = document.createElement('p');
      note.className = 'atr-quick-added';
      note.setAttribute('role', 'status');
      panel.prepend(note);
    }
    note.classList.toggle('is-error', !ok);
    note.textContent = message + ' ';
    if (href) {
      const link = document.createElement('a');
      link.href = href;
      link.textContent = 'View cart';
      note.appendChild(link);
    }
    clearTimeout(note._timer);
    note._timer = setTimeout(() => { note.remove(); }, 5000);
  };

  const refreshCount = () => {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('[data-atr-cart-count]').forEach(el => {
          el.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
        });
      })
      .catch(() => {});
  };

  document.addEventListener('click', event => {
    const button = event.target.closest('.atr-quick-size');
    if (!button || button.disabled) return;
    const panel = button.closest('.atr-quick-panel');
    if (!panel) return;
    event.preventDefault();
    event.stopPropagation();
    const id = Number(button.getAttribute('data-variant'));
    if (!id) return;
    const label = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(response => response.json().then(data => ({ ok: response.ok, data: data })))
      .then(result => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
        if (!result.ok) {
          flash(panel, (result.data && result.data.description) || 'Could not add that one.', false);
          return;
        }
        button.classList.add('is-added');
        setTimeout(() => button.classList.remove('is-added'), 2500);
        flash(panel, 'Added to cart', true, '/cart');
        refreshCount();
      })
      .catch(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
        flash(panel, 'Network error. Try again.', false);
      });
  }, true);

  /* ---- Quantity steppers and card taps ---- */
  document.addEventListener('click', event => {
    const step = event.target.closest('[data-atr-qty-step]');
    if (step) {
      const row = step.closest('.atr-qty-stepper');
      const input = row && row.querySelector('input[type=number]');
      if (!input) return;
      const min = Number(input.min || 1);
      const max = Number(input.max || 99);
      const next = (parseInt(input.value, 10) || min) + Number(step.dataset.atrQtyStep);
      input.value = Math.min(max, Math.max(min, next));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }


  });
})();

